import { djb2 } from "./hashing";

export function uidToColor(uid: string, alpha: string | null = null) {
  const h = djb2(uid) % 360;
  if (alpha === null) {
    return `hsl(${h}, 73%, 78%)`;
  }
  return `hsla(${h}, 73%, 78%, ${alpha})`;
}
